<mat-checkbox
  color="primary"
  style="margin-top: 5px; margin-bottom: 5px"
  [(ngModel)]="checkBool"
  [disabled]="disabled"
  (change)="change($event)"
></mat-checkbox>
<span>{{ LABEL }}</span>
